import { useEffect, useState } from "react";

function TimesheetViewMode({ value = "total", onChange }) {
  const [activeView, setActiveView] = useState(value);

  useEffect(() => {
    setActiveView(value);
  }, [value]);

  const handleSelect = (view) => {
    setActiveView(view);
    if (onChange) {
      onChange(view);
    }
  };

  const getTabClass = (view) =>
    `px-3 py-[6px] rounded-[8px] flex items-center justify-center cursor-pointer
    font-OpenSansSemiBold text-[14px] leading-[20px] tracking-[0.14px] transition-colors duration-150
    ${
      activeView === view
        ? "bg-white text-[#1A2332] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]"
        : "bg-transparent text-[#7C829A]"
    }`;

  return (
    <div className="p-[4px] bg-[#EEF0F9] rounded-[8px] flex items-center gap-[4px]">
      <div onClick={() => handleSelect("day")} className={getTabClass("day")}>
        Day
      </div>
      <div onClick={() => handleSelect("total")} className={getTabClass("total")}>
        Total
      </div>
    </div>
  );
}

export default TimesheetViewMode;
